export const TEST_TYPES = {
  distance_fixed_time: {
    label: 'Distância com tempo limite',
    unit: 'm',
    field: 'Distância percorrida (metros)',
    example: 'Corrida: 2.400 m em 12 minutos',
    timed: true
  },
  repetitions: {
    label: 'Repetições sem tempo definido',
    unit: 'reps',
    field: 'Repetições válidas',
    example: 'Barra ou flexão: pelo menos 5 repetições',
    timed: false
  },
  isometric_hold: {
    label: 'Permanência em posição (isometria)',
    unit: 's',
    field: 'Tempo sustentado',
    example: 'Barra em isometria: pelo menos 20 segundos',
    timed: false
  },
  repetitions_fixed_time: {
    label: 'Repetições em tempo fixo',
    unit: 'reps',
    field: 'Repetições válidas',
    example: 'Abdominal: 35 repetições em 60 segundos',
    timed: true
  }
};
export function parseTrainingTime(minutes, seconds, {
  allowZero = false
} = {}) {
  if (minutes === '' && seconds === '') return null;
  const m = minutes === '' ? 0 : Number(minutes),
    s = seconds === '' ? 0 : Number(seconds);
  const total = m * 60 + s;
  if (!Number.isInteger(m) || !Number.isInteger(s) || m < 0 || s < 0 || s > 59 || total > 86400 || (allowZero ? total < 0 : total <= 0)) throw new Error('Informe minutos inteiros e segundos de 0 a 59.');
  return total;
}
export function formatTrainingTime(seconds) {
  const total = Math.round(Number(seconds)),
    m = Math.floor(total / 60),
    s = total % 60;
  return m ? `${m}min${s ? ` ${String(s).padStart(2, '0')}s` : ''}` : `${s}s`;
}
export function formatTrainingResult(value, type) {
  const num = Number(value);
  if (type === 'isometric_hold') return formatTrainingTime(num);
  return `${num.toLocaleString('pt-BR')} ${type === 'distance_fixed_time' ? 'm' : num === 1 ? 'repetição' : 'repetições'}`;
}
export function formatTrainingRequirement(protocol) {
  const minimum = formatTrainingResult(protocol.minimum_result, protocol.test_type);
  if (protocol.test_type === 'distance_fixed_time') return `${minimum} em até ${formatTrainingTime(protocol.test_duration_seconds)}`;
  return TEST_TYPES[protocol.test_type]?.timed ? `Pelo menos ${minimum} em ${formatTrainingTime(protocol.test_duration_seconds)}` : `Pelo menos ${minimum}`;
}
export function trainingProtocolKey(protocol) {
  return JSON.stringify([protocol.test_type, Number(protocol.minimum_result), protocol.test_duration_seconds == null ? null : Number(protocol.test_duration_seconds)]);
}
export function evaluateTrainingGoal(log, exercise) {
  if (!log) return {
    status: 'empty',
    label: 'Sem registro',
    ratio: 0
  };
  const protocol = log.protocol || exercise;
  if (!log.is_complete_test || log.is_complete_test === '0') return {
    status: 'partial',
    label: 'Treino parcial — sem avaliação da meta',
    ratio: 0
  };
  const value = Number(log.result_value),
    minimum = Number(protocol.minimum_result);
  if (!(minimum > 0)) return {
    status: 'empty',
    label: 'Meta não configurada',
    ratio: 0
  };
  if (protocol.test_type === 'distance_fixed_time') {
    const elapsed = Number(log.elapsed_seconds || protocol.test_duration_seconds);
    const limit = Number(protocol.test_duration_seconds);
    const achieved = value >= minimum && elapsed <= limit;
    return { status: achieved ? 'achieved' : 'below', ratio: Math.min(value / minimum, limit / elapsed),
      label: value < minimum ? `Faltam ${formatTrainingResult(minimum - value, protocol.test_type)} para a distância exigida` : achieved ? 'Meta do edital atingida' : `Tempo acima do limite em ${formatTrainingTime(elapsed - limit)}` };
  }
  const delta = value - minimum;
  return {
    status: delta >= 0 ? 'achieved' : 'below',
    ratio: value / minimum,
    label: delta === 0 ? 'Meta do edital atingida' : delta > 0 ? `Meta do edital atingida: ${formatTrainingResult(delta, protocol.test_type)} acima do mínimo` : `Faltam ${formatTrainingResult(-delta, protocol.test_type)} para a meta`
  };
}
